<template>
  <span class="group relative inline-flex">
    <RouterLink
      v-if="xref.targetVersionId"
      :to="targetRoute"
      :class="[chipClass, kindClass, 'hover:underline focus:outline-none focus:ring-2 focus:ring-primary']"
    >
      {{ label }}
    </RouterLink>
    <span v-else :class="[chipClass, kindClass]">{{ label }}</span>
    <span
      v-if="xref.targetVersionId && xref.targetTitle"
      role="tooltip"
      class="pointer-events-none invisible absolute bottom-full left-1/2 z-20 mb-2 w-max max-w-xs -translate-x-1/2 rounded bg-gray-900 px-2 py-2 text-left text-xs font-normal leading-snug text-white opacity-0 shadow-lg group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100"
    >
      <strong v-if="xref.targetCanonicalRef" class="block">{{ xref.targetCanonicalRef }}</strong>
      {{ xref.targetTitle }}
    </span>
  </span>
</template>

<script setup>
import { computed } from "vue";
import { RouterLink, useRoute } from "vue-router";

const props = defineProps({ xref: { type: Object, required: true } });
const route = useRoute();
const chipClass = "inline-flex h-5 items-center rounded border px-1.5 text-xs font-semibold";
const kindClass = computed(() => ({
  cs: "border-blue-200 bg-blue-50 text-blue-700",
  amc: "border-green-200 bg-green-50 text-green-700",
  gm: "border-yellow-300 bg-yellow-50 text-gray-800",
  appendix: "border-orange-200 bg-orange-50 text-orange-700",
}[props.xref.kind] || "border-gray-200 bg-gray-50 text-gray-600"));
const label = computed(() => props.xref.target || props.xref.raw);
const browseRouteName = computed(() => {
  if (route.query.partNumber === "23") return "CS23";
  if (route.query.partNumber === "25") return "CS25";
  return route.name === "CS23" ? "CS23" : "CS25";
});
const targetRoute = computed(() => ({
  name: browseRouteName.value,
  query: {
    versionId: props.xref.targetVersionId,
    amendment: route.query.amendment,
  },
}));
</script>
